import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';

const routerOptions: ExtraOptions = {
	scrollOffset: [0, 72],
	initialNavigation: 'enabledBlocking',
	scrollPositionRestoration: 'enabled',
	relativeLinkResolution: 'legacy',
};

const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		data: { title: 'Nutrition Care Made Clear' },
		component: LayoutComponent,
		children: [
			{
				path: '',
				data: { title: 'Home' },
				loadChildren: () => import('app/pages/home-v2/home-v2.module').then((h) => h.HomeV2Module),
			},
		],
	},
	{
		path: 'webstories',
		data: { title: 'Web Story Detail' },
		loadChildren: () =>
			import('app/apps/web-story-detail/web-story-detail.module').then(
				(b) => b.WebStoryDetailModule,
			),
	},
	{
		path: '',
		component: LayoutComponent,
		children: [
			{
				path: 'blogs',
				data: { title: 'Blogs' },
				loadChildren: () => import('app/apps/blogs/blogs.module').then((b) => b.BlogsModule),
			},
			{
				path: 'web-stories',
				data: { title: 'Web Stories' },
				loadChildren: () =>
					import('app/apps/web-stories/web-stories.module').then((b) => b.WebStoriesModule),
			},
			{
				path: 'products',
				data: { title: 'Products' },
				loadChildren: () =>
					import('app/apps/products/products.module').then((p) => p.ProductsModule),
			},
			{
				path: 'resources',
				data: { title: 'Resources' },
				loadChildren: () =>
					import('app/pages/resources/resources.module').then((r) => r.ResourcesModule),
			},
			{
				path: 'policy',
				data: { title: 'Privacy Policy' },
				loadChildren: () =>
					import('app/pages/privacy-policy/privacy-policy.module').then(
						(c) => c.PrivacyPolicyModule,
					),
			},
			{
				path: 'terms',
				data: { title: 'Terms Of Use' },
				loadChildren: () => import('app/pages/terms/terms.module').then((c) => c.TermsModule),
			},
			{
				path: 'references',
				data: { title: 'References - Hint' },
				loadChildren: () =>
					import('app/pages/references/references.module').then((c) => c.ReferencesModule),
			},
			{
				path: 'shipping',
				data: { title: 'Shipping Detail' },
				loadChildren: () =>
					import('app/pages/shipping-detail/shipping-detail.module').then((c) => c.ShippingDetailModule),
			},
			{
				path: 'recipes',
				data: { title: 'Recipes' },
				loadChildren: () => import('app/pages/recipes/recipes.module').then((c) => c.RecipesModule),
			},
			{
				path: 'store',
				redirectTo: 'store/garmin-watches',
				pathMatch: 'full',
			},
			{
				path: 'store/garmin-watches',
				loadChildren: () => import('app/pages/store/store.module').then((m) => m.StoreModule),
			},
			{
				path: 'contact',
				data: { title: 'Contact' },
				loadChildren: () => import('app/pages/contact/contact.module').then((c) => c.ContactModule),
			},
		],
	},
	{
		path: 'error',
		data: { title: 'Error' },
		loadChildren: () => import('app/pages/error/error404.module').then((e) => e.Error404Module),
	},
	{
		path: '**',
		redirectTo: '/error',
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, routerOptions)],
	exports: [RouterModule],
})
export class AppRoutingModule { }
